import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class VpOfEngineering extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/" />
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/" />
                    </div>
                    <div className="header-title">
                        <h2>VP Of Engineering</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">
                        <SNIntro />

                        <p className="p2">
                            Founded by veterans of Salesforce, Google, Scopely and Applied
                            Semantics whose past startups have created over $6B in equity value,
                            we're building another industry transforming company. We're off to a
                            fantastic start, and we're looking for A+ players to help take us to
                            the next level.
                        </p>

                        <br />

                        <p className="p2">
                            {"The VP of Engineering at Social Native will act as the managing lead \
                            for our ever-growing team of software engineers. You will lead this \
                            team using the latest technologies to develop a high performing, \
                            seamless platform to deliver high-quality content to brands and \
                            agencies. You will have a hand in architecture, design, and \
                            implementation as you thoughtfully lead a team of highly skilled \
                            engineers in Los Angeles and remote."}
                        </p>

                        <br />

                        <p className="p2">
                            {"Social Native's technology allows brands to quickly and economically \
                            create hundreds of high quality, personalized images, and videos \
                            through our global network of exceptional micro-influencers. Our \
                            content has proven to outperform traditional content, for a fraction of \
                            the cost."}
                        </p>

                        <br />

                        <p className="p1">
                            <span className="s1">
                                <b>Responsibilities</b>
                            </span>
                        </p>
                        <ul className="l1">
                            <li className="p3">
                                Lead our engineering team by owning their processes, priorities,
                                and long-term goals.
                            </li>
                            <li className="p3">
                                {"Improve individual contributors' and managers' performance, \
                                processes, and quality across the whole engineering team."}
                            </li>
                            <li className="p3">
                                Partner with Leadership Teams, Product, Account Manager, Sales,
                                Finance, and Marketing to ensure company goals are aligned and met.
                            </li>
                            <li className="p3">
                                Contribute to the product roadmap and resource planning/allocation.
                            </li>
                            <li className="p3">
                                Help to recruit, hire, and retain top engineering talent. Work
                                closely with Recruiting — in particular, interview candidates and
                                co-own activities related to lead generation (e.g. tech talks) and
                                screening (e.g. HackerRank tests).
                            </li>
                            <li className="p3">
                                Work with the product management team to implement and prioritize
                                across multiple product lines. Show good judgement in trade-offs
                                and schedules.
                            </li>
                            <li className="p3">
                                Promptly resolve issues faced during operationalization by working
                                with different stakeholders. Provide thought leadership and
                                recommendations to stakeholders based on best practices and
                                experience working in a diverse environment.
                            </li>
                        </ul>

                        <p className="p1">
                            <span className="s1">
                                <b>Preferred Qualifications</b>
                            </span>
                        </p>
                        <ul className="l1">
                            <li className="p3">
                                We expect that you exceed a majority of our senior engineers as an
                                individual contributor, and that you surpass any of our Engineering
                                Directors as a manager
                            </li>
                            <li className="p3">7+ years of industry experience</li>
                            <li className="p3">
                                5+ years of experience as a developer (ideally still hands on)
                            </li>
                            <li className="p3">3+ years of direct management experience</li>
                            <li className="p3">
                                Expert-level knowledge of: o JavaScript and PHP; experience such
                                front-end frameworks like React and serverside JavaScript using
                                Node.js is preferred o Git, unit testing, debugging, profiling,
                                performance monitoring
                            </li>
                            <li className="p3">
                                B.S., M.S. or PhD in Computer Science, Physics, Engineering or a
                                related technical field
                            </li>
                        </ul>

                        <p className="p1">
                            <span className="s1">
                                <b>Relevant Technology</b>
                            </span>
                        </p>

                        <ul className="l1">
                            <li className="p2">Languages</li>
                            <ul className="l2">
                                <li className="p3">Javascript (ES6)</li>
                                <li className="p3">PHP</li>
                                <li className="p3">Java</li>
                                <li className="p3">Python</li>
                            </ul>

                            <li className="p2">Databases</li>
                            <ul className="l2">
                                <li className="p3">MySQL / Postgres</li>
                                <li className="p3">Elasticsearch</li>
                                <li className="p3">Redis</li>
                            </ul>

                            <li className="p2">Frameworks</li>
                            <ul className="l2">
                                <li className="p3">Node.js</li>
                                <li className="p3">React.js / Redux</li>
                                <li className="p3">Laravel</li>
                                <li className="p3">Webpack + Babel</li>
                            </ul>

                            <li className="p2">Infrastructure (Amazon Web Services)</li>
                            <ul className="l2">
                                <li className="p3">Elastic Beanstalk</li>
                                <li className="p3">Lambda</li>
                                <li className="p3">Relational Database Service</li>
                                <li className="p3">Elastic Container Service</li>
                                <li className="p3">Elastic Compute Cloud</li>
                                <li className="p3">Simple Storage Service</li>
                                <li className="p3">Simple Notification Service</li>
                            </ul>
                        </ul>

                        <p className="p1">
                            <span className="s1">
                                <b>Engineering Culture at SN</b>
                            </span>
                        </p>

                        <ul className="l1">
                            <li className="p2">Follow best practices.</li>
                            <li className="p2">Use the best tool for the job.</li>
                            <li className="p2">Write quality code.</li>
                            <li className="p2">Own and contribute to the product.</li>
                            <li className="p2">Be humble and respect the ideas of others.</li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/vp_of_engineering.js